import { useQuery, useMutation } from 'react-query'
import axios from 'axios'
import { safePromise } from 'utils/universal/safePromise'
import { getFormData } from 'utils/digitalExpedient/getFormData'

const useDigitalExpedient = (expId, tokenAuth, enabled) => useQuery(
  ['digital-expedient', { expId, tokenAuth }],
  async () => {
    const headers = {
      'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${tokenAuth}`,
      accept: 'application/json',
    }
    const url = `${process.env.NEXT_PUBLIC_DOCUMENT_URL}/${expId}`
    const { data } = await axios.get(url, {
      params: {},
      headers,
    })
    return data
  },
  {
    enabled,
    refetchOnWindowFocus: false,
    refetchOnmount: false,
    refetchOnReconnect: false,
    retry: false,
    staleTime: 1000 * 60 * 24,
  },
)

const useDigitalExpedientMutation = () => useMutation(
  async ({ expId, tokenAuth, data }) => {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${tokenAuth}`,
      accept: 'application/json',
    }
    const { result } = await safePromise(
      axios.put(`${process.env.NEXT_PUBLIC_DOCUMENT_URL}/${expId}`,
        data,
        { headers }),
    )
    return result.data
  },
)

const useDocumentMutation = () => useMutation(
  async ({ expId, tokenAuth, data }) => {
    const headers = {
      'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${tokenAuth}`,
      accept: 'application/json',
    }

    const { result } = await safePromise(axios.post(
      `${process.env.NEXT_PUBLIC_DOCUMENT_URL}/${expId}/documents`,
      getFormData(data),
      {
        headers,
      },
    ))
    return result.data
  },
)

export {
  useDigitalExpedient,
  useDigitalExpedientMutation,
  useDocumentMutation,
}
